import commonActions from 'top20common/distribution/store/actions';

export default {
  ...commonActions,
  copyLinkAction(context) {
    document.getElementById('copyInput').select();
    document.execCommand('copy');
  }
};
